"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeUrl = exports.default = void 0;
var _dompurify = _interopRequireDefault(require("dompurify"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const sanitize = value => {
  return _dompurify.default.sanitize(value, {
    USE_PROFILES: {
      html: true
    }
  });
};
var _default = exports.default = sanitize;
const sanitizeUrl = (url, options) => {
  if (options.https) {
    return url.startsWith('https') ?? url;
  }
  return url.startsWith('http') ?? url;
};
exports.sanitizeUrl = sanitizeUrl;
//# sourceMappingURL=CoreSanitize.js.map